import { initAccordion } from "./modules/accordion/init-accordion";
import { initCustomSelect } from "./modules/custom-select/init-custom-select";
import { initHeader } from "./modules/header/init-header";
import { initModals } from "./modules/modal/init-modals";
import { initPhoneMask } from "./modules/init-phone-mask";
import { initPhoneValidation } from "./modules/init-phone-validation";
import { initTabs } from "./modules/tabs/init-tabs";
import { initTabsSlider } from "./modules/sliders/init-tabs-slider";
import { initSpecialsSlider } from "./modules/sliders/init-specials-slider";
import { subMenuHandler } from "./modules/header/sub-menu-handler";
import { openMenuHandler } from "./modules/header/open-menu-handler";
import { initFancybox } from "./modules/fancybox/init-fancybox";
import { initShowMore } from "./modules/show-more/init-show-more";
import { initGetContent } from "./modules/get-content/init-get-content";
import { initRecaptcha } from "./modules/init-recaptcha";
import { initFileUpload } from "./modules/file-upload/init-file-upload";
import {initPayment} from './modules/payment/init-payment';
import { initPersonalAccount } from "./modules/personal-account/init-personal-account";
import {initDeleteApplication} from './modules/init-delete-application';

window.addEventListener("DOMContentLoaded", () => {
  initHeader();
  initModals();
  initAccordion();
  initTabs();
  initSpecialsSlider();
  initTabsSlider();
  subMenuHandler();
  openMenuHandler();
  initFancybox();
  initShowMore();
  initGetContent();
  initRecaptcha();
  initFileUpload();
  initPayment();
  initPersonalAccount();
  initDeleteApplication();

  window.addEventListener("load", () => {
    initCustomSelect();
    initPhoneMask();
    initPhoneValidation();
  });
});

// showMoreBtnHandler('[data-group="youngest"]', ".artists-card", 8);
// showMoreBtnHandler('[data-group="elder"]', ".artists-card", 8);
// showMoreBtnHandler(".jury", ".jury-card", 8);
// showMoreBtnHandler(".archive-page-block", ".archive-card", 6);
// showMoreBtnHandler(".news-page", ".news-card__wrapper", 6);
// showMoreBtnHandler(".gallery-page-block", ".gallery-card ", 8);
// showMoreBtnHandler(".video", ".broadcast-card ", 6);
